import { useGlobalStore } from "@hooks/useGlobalStore";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "../../configs/locales/en-US.json";
import translationJa from "../../configs/locales/ja-JP.json";
import translationZh from "../../configs/locales/zn-CN.json";

export const resources = {
	"en-US": { translation: translationEn },
	"zh-CN": { translation: translationZh },
	"ja-JP": { translation: translationJa },
};

const initI18n = () => {
	const { getState } = useGlobalStore;
	i18n.use(initReactI18next).init({
		compatibilityJSON: "v4",
		resources,
		lng: getState().language || "en-US",
		fallbackLng: "en-US",
		interpolation: {
			escapeValue: false,
		},
	});
};

initI18n();

export default i18n;
